module.exports = __webpack_public_path__ + "img/airplane.b7643552.svg";